module.exports = __webpack_public_path__ + "img/foto_3.5c2e24c3.png";